type ClassValue = string | number | boolean | undefined | null;
type ClassArray = ClassValue[];
type ClassDictionary = Record<string, any>;
type ClassName = ClassValue | ClassArray | ClassDictionary;

export function cn(...inputs: ClassName[]): string {
  const classes = inputs.filter(Boolean).join(' ');
  return classes;
}